import { Box } from "@mui/material";
import { ClipLoader, ScaleLoader } from "react-spinners";
const Loader = ({ color }) => {
  return (
    <Box>
      <ClipLoader color={color} speedMultiplier={1} radius={2} width={6} />
    </Box>
  );
};

export { Loader };
